import ColorPicker from "@/components/ColorPicker";
import { Drawer, FormHelperText, Stack, Typography } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { OnboardingFormValues } from "../Onboarding";
import { useFormikContext } from "formik";
import { useState } from "react";

const ColorStep = () => {
    const [isLogoVisible, setIsLogoVisible] = useState(false);
    const { values, setFieldValue } = useFormikContext<OnboardingFormValues>();

    const handleColorChange = (e: { target: { value: string; name: string; }; }) => {
        setFieldValue(e.target.name, e.target.value);

        if (values?.logo || values?.isotype) {
            setIsLogoVisible(false);
        }
    }

    return (
        <Stack spacing={3}>
            <Typography textAlign="center" variant="h1" color="white">Elige los colores de tu marca</Typography>
            <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Stack spacing={1}>
                        <Typography variant="h4" color="white">Color Primario</Typography>
                        <ColorPicker
                            condensed
                            name="primaryColor"
                            value={values.primaryColor}
                            onChange={handleColorChange}
                            onEyeDropperClicked={() => {
                                setIsLogoVisible(true);
                            }}
                        />
                        <FormHelperText sx={{ color: 'white', paddingX: 2, opacity: 0.75 }}>
                            Se utiliza en botones, enlaces y otros elementos de llamado a la acción
                        </FormHelperText>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Stack spacing={1}>
                        <Typography variant="h4" color="white">Color Secundario</Typography>
                        <ColorPicker
                            condensed
                            name="secondaryColor"
                            value={values.secondaryColor}
                            onChange={handleColorChange}
                            onEyeDropperClicked={() => {
                                setIsLogoVisible(true);
                            }}
                        />
                        <FormHelperText sx={{ color: 'white', paddingX: 2, opacity: 0.75 }}>
                            Se utiliza en elementos de llamado a la acción secundario asi como fondos para resaltar otros elementos primarios
                        </FormHelperText>
                    </Stack>
                </Grid>
            </Grid>
            <Drawer
                anchor="bottom"
                open={isLogoVisible}
                onClose={() => setIsLogoVisible(false)}
            >
                <Stack direction="row" spacing={3} paddingX={3} paddingY={5} justifyContent="space-around" alignItems="center">
                    {values?.logo ? (
                        <img src={URL.createObjectURL(values.logo)} alt="Logotipo" width="200px" height="auto" />
                    ) : null}
                    {values?.isotype ? (
                        <img src={URL.createObjectURL(values.isotype)} alt="Isotipo" width="200px" height="auto" />
                    ) : null}
                </Stack>
            </Drawer>
        </Stack>
    )
}

export default ColorStep;
